import styled, { css } from 'styled-components'
import { Preview } from 'ui/components/forms/EditorPreview/styled'

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${({ $compactPreview }) =>
    $compactPreview &&
    css`
      ${Preview} {
        margin-bottom: 0;
      }
    `}
`

export const DescriptionTitle = styled.div`
  color: var(--t-template-description-title-color);
`
